<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-flex xs12 mb-3><h1 class="max">{{i18n('Download de recibo de pagamento')}}</h1></v-flex>
      <v-flex v-if="this.loaded">{{ i18n('Data da transferência: ') + receipt_date }}</v-flex>
      <v-flex v-if="this.loaded">{{`${i18n('Valor')}: ${(receipt_data.value)}`}}</v-flex>
      {{i18n(feedback_msg)}}
    </v-container>
  </layout>
</template>

<script>
  import jsPdf from 'jspdf'
  import ImgAssets from '../../static/receipt_imgs.js'
  import BaseLeftBarLayout from "../layouts/BaseLeftBarLayout"
  import utils from "../shared/Utils"

  export default {
    name: 'ReceiptPage',
    components: {
      layout: BaseLeftBarLayout,
    },
    data: (vm) => {
      return {
        lang: vm.$root.lang,
        loaded: false,
        receipt_data: {},
        feedback_msg: 'O seu arquivo está pronto para ser baixado. Clique no botão ao lado para fazer o download.'
      }
    },
    computed: {
      receipt_date() {
        if (this.lang == 'pt') return utils.dbDateTimeToHuman(this.receipt_data.inserted_at)
        return utils.dbDateTimeToHuman(this.receipt_data.inserted_at, 'en-US') + ' (GMT-3)'
      },
      fromBankAccount() {
        if (this.fromBankAccountBankCode() == 999) {
          return ''
        }
        return `${this.fromBankAccountBankCode()} - ${this.fromBankAccountBankName()} - ${this.receipt_data.from_bank_account.account_number}`
      }
    },
    methods: {
      i18n(str) {
        return this.$root.i18n[str] && this.$root.i18n[str][this.lang] || str
      },
      localeCurrency(value, currency) {
        return this.$root.localeCurrency(value, currency)
      },
      loadReceiptData() {
        const id = this.$route.params.id
        let successCallback = (response) => {
          if (response.body.data) {
            this.receipt_data = response.body.data
            this.receipt_data.value = this.localeCurrency(this.receipt_data.value, this.receipt_data.currency)
            this.createPDF()
          } else {
            console.log('successCallback', response)
          }
        }

        let errorCallback = (response) => {
          console.log('errorCallback', response)
          this.feedback_msg = 'Não foi possível carregar os dados do recibo informado: ' + response.body.error
        }

        this.$http.get(`${this.$root.urls.customer__receipt}${id}`).then(successCallback, errorCallback)
      },
      createPDF() {
        var doc = new jsPdf({ putOnlyUsedFonts: true });

        doc.addImage("static/facilitapay_logo.jpg", "JPEG", 70, 15, 65, 22);
        doc.setFontSize(25);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(10, 45, 74);
        doc.setDrawColor(128, 128, 128)
        doc.text(this.i18n("Transferência Realizada"), 108, 55, null, null, "center");

        doc.setFontSize(16);
        // calculating offset for circle icon
        const base_text_width = 51.92
        let text_dimentions = doc.getTextDimensions(this.receipt_date);
        const delta_width = (base_text_width - text_dimentions.w) / 2

        doc.addImage("static/small-circle.jpg", "JPEG", 75 + delta_width, 59, 8, 8);
        doc.text(this.receipt_date, 110, 65, null, null, "center");
        doc.line(30, 70, 180, 70);

        doc.setFontSize(15);
        doc.setTextColor(190, 190, 190);
        doc.text(this.i18n("Valor"), 30, 80)
        doc.text(this.i18n("De"), 30, 105)
        doc.text(this.i18n("Para"), 30, 155)
        doc.text(this.i18n("Finalidade: Crédito em Conta"), 30, 240)

        if (this.receipt_data.to_bank_account.pix_info && this.receipt_data.to_bank_account.pix_info.end_to_end_id) {
          doc.text(this.i18n("Identificador"), 30, 255)
        }

        doc.text(this.i18n("ID da Transferência"), 30, 275)

        doc.setFontSize(22);
        doc.setTextColor(10, 45, 74);
        doc.text(this.receipt_data.value, 30, 90);

        doc.line(30, 95, 180, 95);

        doc.setFontSize(20);
        doc.text(this.fromBankAccountOwnerName(), 30, 115, {charSpace: -0.4})

        doc.setFontSize(18);
        doc.text(this.fromBankAccountOwnerDocumentInfo(), 30, 125, {charSpace: -0.5});
        doc.text(this.fromBankAccount, 30, 135, {charSpace: -0.5});

        doc.text(`${this.toBankAccountOwnerName()}`, 30, 165, {charSpace: -0.5})
        doc.text(`${this.toBankAccountOwnerDocumentType()} - ${this.toBankAccountOwnerDocumentNumber()}`, 30, 175, {charSpace: -0.5})

        if (!this.isBankPix()) {
          doc.text(`${this.toBankAccountBankCode()}`, 30, 185, {charSpace: -0.5})

          const [line1, line2] = this.splitTextByLength(this.toBankAccountBankName(), 40);

          doc.text(line1, 30, 195, {charSpace: -0.5});

          if (line2) {
            doc.text(line2, 30, 205, {charSpace: -0.5});
            doc.text(`${this.toBankAccountBranchNumber()} / ${this.toBankAccountAccountNumber()}`, 30, 215, {charSpace: -0.5});
            doc.text(`${this.toBankAccountPixInfo()}`, 30, 225, {charSpace: -0.5});
          } else {
            const bankAccountInfo = [
              this.toBankAccountBranchNumber(),
              this.toBankAccountAccountNumber()]
              .filter((v)=> v !== '')
              .join(' / ')

            doc.text(`${bankAccountInfo}`, 30, 215, {charSpace: -0.5});
            doc.text(`${this.toBankAccountPixInfo()}`, 30, 225, {charSpace: -0.5});
          }
        } else {
          doc.text(`${this.toBankAccountPixInfo()}`, 30, 185, {charSpace: -0.5})
        }

        if (this.receipt_data.to_bank_account.pix_info && this.receipt_data.to_bank_account.pix_info.end_to_end_id) {
          doc.text(`${this.receipt_data.to_bank_account.pix_info.end_to_end_id.toUpperCase()}`, 30, 265);
        }

        doc.text(`${this.receipt_data.id.toUpperCase()}`, 30, 285);
        doc.line(30, 230, 180, 230);

        doc.setFillColor(10, 45, 74);
        doc.rect(20, 0, 170, 5, "F");
        doc.rect(20, 295, 170, 10, "F");

        this.loaded = true;
        this.feedback_msg = 'O download do arquivo foi iniciado. Verifique a pasta de downloads!'

        doc.save(`Receipt-${this.receipt_data.id}.pdf`)
      },
      splitTextByLength(text, maxLength) {
        if (text.length <= maxLength) return [text];

        const words = text.split(' ');
        let firstLine = '';
        let secondLine = '';

        for (let word of words) {
          if ((firstLine + word).length <= maxLength) {
            firstLine += (firstLine ? ' ' : '') + word;
          } else {
            secondLine += (secondLine ? ' ' : '') + word;
          }
        }

        return [firstLine, secondLine];
      },
      fromBankAccountOwnerName() {
        try { return this.receipt_data.from_bank_account.owner_name } catch(_err) { return 'N/A' }
      },
      fromBankAccountOwnerDocumentInfo() {
        try {
          if (this.receipt_data.from_bank_account.owner_document_type && this.receipt_data.from_bank_account.owner_document_number) {
            return this.receipt_data.from_bank_account.owner_document_type.toUpperCase() + ' - ' + this.receipt_data.from_bank_account.owner_document_number
          } else if (this.receipt_data.from_bank_account.owner_document_number) {
            return this.receipt_data.from_bank_account.owner_document_number
          } else {
            return ''
          }
        } catch(_err) {
          return 'N/A'
        }
      },
      fromBankAccountBankCode() {
        try { return this.receipt_data.from_bank_account.bank.code || this.receipt_data.from_bank_account.bank.swift } catch(_err) { return 'N/A' }
      },
      fromBankAccountBankName() {
        try { return this.receipt_data.from_bank_account.bank.name } catch(_err) { return 'N/A' }
      },
      toBankAccountOwnerName() {
        return this.receipt_data.to_bank_account.owner_name || this.receipt_data.to_bank_account.company.social_name
      },
      toBankAccountBankCode() {
        try {
          const isPresent = value => value !== null && value !== ""
          const bank = this.receipt_data.to_bank_account.bank
          const ispb = this.toBankAccountISPBCode()

          if (isPresent(bank.code) && isPresent(ispb)) {
            return `${this.i18n('Código do Banco')}: ${bank.code} - ISPB: ${ispb}`
          }

          if (isPresent(bank.code)) {
            return `${this.i18n('Código do Banco')}: ${bank.code}`
          }

          if (isPresent(ispb)) {
            return `ISPB: ${ispb}`
          }

          if (isPresent(bank.swift)) {
            return `Swift: ${bank.swift}`
          }

          return ""
        } catch(_err) {
           return 'N/A'
        }
      },
      toBankAccountISPBCode() {
        return this.receipt_data.to_bank_account.bank.ispb || this.receipt_data.to_bank_account.pix_info.ispb
      },
      toBankAccountBankName() {
        const toBankAccount = this.receipt_data.to_bank_account;
        const bank_swift = toBankAccount.bank.swift || '';

        if (!toBankAccount) {
          return 'N/A';
        }

        const bankName = bank_swift.startsWith("BCBPIX")
          ? toBankAccount.pix_info.bank_name
          : toBankAccount.bank.name;

        return bankName
          ? `${this.i18n('Banco')}: ${bankName}`
          : 'N/A';
      },
      toBankAccountBranchNumber() {
        try {
          let branch_number = this.receipt_data.to_bank_account.branch_number || this.receipt_data.to_bank_account.pix_info.branch_number
          if (branch_number) {
            return this.i18n('Agência') + ': ' + branch_number
          } else {
            return ''
          }
        } catch(_err) {
          return ''
        }
      },
      toBankAccountAccountNumber() {
        try {
          let account_number = this.receipt_data.to_bank_account.account_number || this.receipt_data.to_bank_account.pix_info.account_number
          if (account_number) {
            return this.i18n('Conta') + ': ' + account_number
          } else {
            return ''
          }
        } catch(_err) {
          return ''
        }
      },
      toBankAccountOwnerDocumentNumber() {
        try { return utils.mask(this.receipt_data.to_bank_account.company.document_type, this.receipt_data.to_bank_account.company.document_number) } catch(_err) { return 'N/A' }
      },
      toBankAccountOwnerDocumentType() {
        try { return this.receipt_data.to_bank_account.company.document_type.toUpperCase() } catch(_err) { return 'N/A' }
      },
      toBankAccountPixInfo() {
        try {
          if(this.receipt_data.to_bank_account.pix_info.type && this.receipt_data.to_bank_account.pix_info.key) {
            return `Pix info ${this.receipt_data.to_bank_account.pix_info.type} - ${this.receipt_data.to_bank_account.pix_info.key}`
          } else {
            return ''
          }
        } catch(_err) {
          return ''
        }
      },
      isBankPix() {
        return this.toBankAccountBankCode().includes('BCBPIX') && this.toBankAccountBankCode().includes('000')
      }
    },
    mounted() {
      this.$root.$on('downloadReceipt', () => this.loadReceiptData())
      this.$root.$on('syncLang', (lang) => this.lang = lang)
    },
    metaInfo: {
      title: "Facilita Pay"
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/ReceiptPage.vue